import React from 'react'
import './Footer.css';

const Footer = () => {
  return (
    <div>
        <footer className='footer'>
            <div className='footer-text'>
            <p>Copyright &copy; 2024 by Lakshan Hewagama</p>
            </div>

            <div className='footer-iconTop'>
                <a href='#home'><i class="fa-solid fa-angle-up"></i></a>
            </div>


            
        </footer>
    </div>
  )
}

export default Footer